<template>
  <div class="vmcms">
    <div class="powerful_code-main">
      <div v-if="editMode" class="config-title-bar">
        <label class="config-title-label">标题：</label>
        <input v-model="pageTitle" class="config-title-input" placeholder="请输入页面标题，仅备注用" />
      </div>
      <!-- 编辑器部分 -->
      <div class="editor-tools" v-if="editMode">
        <div class="tool-section">
          <button @click="addTextBlock">添加文字</button>
          <button @click="addImageBlock">添加图片</button>
          <button @click="addButtonBlock">添加按钮</button>
          <button @click="addLinkBlock">添加链接</button>
        </div>
        <div class="preview-toggle">
          <button @click="toggleEditMode">预览页面</button>
        </div>
      </div>

      <!-- 预览/展示部分 -->
      <div class="page-app" :class="{ active: !editMode }">
        <div class="page-phone" style="background: rgb(255, 255, 255)">
          <!-- 添加预览模式下的返回按钮 -->

          <div class="page-render page">
            <!-- 动态内容区域 -->
             <div
                v-for="(item, index) in contentItems"
                :key="item.uid || index"
                class="content-item"
                :class="{ 'editing-item': editMode }"
              >

              <!-- 编辑模式下的控制按钮 -->
              <div v-if="editMode" class="item-controls">
                <button @click="moveUp(index)" :disabled="index === 0">
                  上移
                </button>
                <button
                  @click="moveDown(index)"
                  :disabled="index === contentItems.length - 1"
                >
                  下移
                </button>
                <button @click="removeItem(item.uid, index)">删除</button>
              </div>

              <!-- 文字内容 -->
              <div v-if="item.type === 'text'" class="rich-text-box-wrapper">
                <button 
                  v-if="!editMode"
                  class="copy-text-btn"
                  :class="{ 'copied': copiedTextBlocks[index] }"
                  @click="copyTextContent(index, item)"
                  title="复制文字内容"
                >
                  点击复制
                </button>
                <div v-if="editMode" class="rich-text-toolbar">
                  <select
                    v-model="item.style.fontSize"
                    @change="
                      applyTextStyle(index, 'fontSize', $event.target.value)
                    "
                  >
                    <option value="12px">12px</option>
                    <option value="14px">14px</option>
                    <option value="16px" selected>16px</option>
                    <option value="18px">18px</option>
                    <option value="20px">20px</option>
                    <option value="24px">24px</option>
                    <option value="28px">28px</option>
                    <option value="32px">32px</option>
                  </select>

                  <button
                    @click="toggleTextStyle(index, 'bold')"
                    :class="{ active: item.style.fontWeight === 'bold' }"
                    title="加粗"
                  >
                    <strong>B</strong>
                  </button>

                  <button
                    @click="toggleTextStyle(index, 'italic')"
                    :class="{ active: item.style.fontStyle === 'italic' }"
                    title="斜体"
                  >
                    <em>I</em>
                  </button>

                  <button
                    @click="toggleTextStyle(index, 'underline')"
                    :class="{
                      active: item.style.textDecoration === 'underline',
                    }"
                    title="下划线"
                  >
                    <u>U</u>
                  </button>

                  <!-- 颜色选择器部分 -->
                  <div class="color-picker-wrapper">
                    <button
                      class="color-picker-button"
                      @click="toggleColorPicker(index)"
                      :style="{
                        backgroundColor: item.style.color || '#000000',
                      }"
                      title="文字颜色"
                    ></button>
                    <div
                      v-if="activeColorPicker === index"
                      class="color-picker-popup"
                    >
                      <div
                        v-for="color in predefinedColors"
                        :key="color"
                        class="color-option"
                        :style="{ backgroundColor: color }"
                        @click="applyTextColor(index, color)"
                      ></div>
                    </div>
                  </div>

                  <select
                    v-model="item.style.textAlign"
                    @change="
                      applyTextStyle(index, 'textAlign', $event.target.value)
                    "
                  >
                    <option value="left">左对齐</option>
                    <option value="center">居中</option>
                    <option value="right">右对齐</option>
                    <option value="justify">两端对齐</option>
                  </select>

                  <input
                    type="number"
                    v-model.number="item.style.lineHeight"
                    min="1"
                    max="3"
                    step="0.1"
                    @change="
                      applyTextStyle(index, 'lineHeight', $event.target.value)
                    "
                    title="行高"
                  />
                </div>

                <div
                  :ref="(el) => setEditableRef(el, index)"
                  class="editor-content-view"
                  :style="getTextStyle(item.style)"
                  contenteditable="true"
                  @focus="setActiveTextIndex(index)"
                  @input="(e) => updateTextContent(index, e)"
                  @mouseup="saveSelection"
                  @keyup="saveSelection"
                  @compositionstart="handleCompositionStart"
                  @compositionend="(e) => handleCompositionEnd(e, index)"
                ></div>
              </div>

              <!-- 图片内容 -->
              <div v-if="item.type === 'image'" class="banner-img">
                <div v-if="editMode" class="rich-text-toolbar">
                  <div class="url-input-group">
                    <input
                      v-model="item.src"
                      placeholder="输入图片URL"
                      class="large-input"
                    />
                    <button @click="item.src = ''" class="clear-button">×</button>
                    <!-- 上传按钮 -->
                    <button @click="triggerImageUpload(index)" class="upload-button">上传图片</button>
                    <!-- 修改文件输入元素的 ref 绑定 -->
                    <input
                      type="file"
                      :ref="(el) => setFileInputRef(el as HTMLInputElement, index)"
                      @change="handleImageUpload($event, index)"
                      accept="image/*"
                      style="display: none"
                    />
                  </div>
                  <select v-model="item.style.border">
                    <option value="">无边框</option>
                    <option value="1px solid red">红色边框</option>
                    <option value="1px solid blue">蓝色边框</option>
                    <option value="1px dashed gray">灰色虚线</option>
                  </select>
                  <!-- 上传状态提示 -->
                  <div v-if="uploadStatus[index]" class="upload-status" :class="uploadStatus[index].type">
                    {{ uploadStatus[index].message }}
                  </div>
                </div>
                <img :src="item.src" :alt="item.alt || '图片'" :style="item.style" @click="editMode && triggerImageUpload(index)" />
              </div>

              <!-- 按钮内容 -->
              <div v-if="item.type === 'button'">
                <div v-if="editMode" class="rich-text-toolbar button-toolbar">
                  <div class="button-input-group">
                    <label>按钮文本:</label>
                    <div class="url-input-group">
                      <input
                        v-model="item.text"
                        placeholder="请输入按钮文本"
                        class="large-input"
                      />
                      <button @click="item.text = ''" class="clear-button">×</button>
                    </div>
                  </div>
                  <div class="button-input-group">
                    <label>跳转链接:</label>
                    <div class="url-input-group">
                      <input
                        v-model="item.link"
                        placeholder="请输入跳转链接"
                        class="large-input"
                      />
                      <button @click="item.link = ''" class="clear-button">×</button>
                    </div>
                  </div>
                  <div class="button-style-group">
                    <div class="style-control">
                      <label>背景颜色:</label>
                      <input type="color" v-model="item.style.background" />
                    </div>
                    <div class="style-control">
                      <label>文本颜色:</label>
                      <input type="color" v-model="item.style.color" />
                    </div>
                  </div>
                </div>
                <button
                  class="coppy_button"
                  :style="{
                    background:
                      item.style.background ||
                      'linear-gradient(90deg, rgb(251, 136, 77) 0%, rgb(247, 62, 40) 100%)',
                    color: item.style.color || '#ffffff',
                  }"
                  @click="handleButtonClick(item)"
                >
                  {{ item.text }}
                </button>
              </div>

              <!-- 链接内容 -->
              <div v-if="item.type === 'link'">
                <div v-if="editMode" class="rich-text-toolbar">
                  <div class="url-input-group">
                    <input
                      v-model="item.text"
                      placeholder="链接文本（留空则显示URL）"
                      class="large-input"
                    />
                    <button @click="item.text = ''" class="clear-button">×</button>
                  </div>
                  <div class="url-input-group">
                    <input
                      v-model="item.url"
                      placeholder="链接URL"
                      class="large-input"
                    />
                    <button @click="item.url = ''" class="clear-button">×</button>
                  </div>
                  <div class="style-control-group">
                    <div class="style-control">
                      <label>颜色: </label>
                      <input type="color" v-model="item.style.color" />
                    </div>
                    <div class="style-control">
                      <label>下划线: </label>
                      <input type="checkbox" v-model="item.style.textDecoration" />
                    </div>
                  </div>
                </div>
                <div class="link_box">
                  <a
                  :href="item.url"
                  target="_blank"
                  :style="{
                    color: item.style.color,
                    textDecoration: item.style.textDecoration
                      ? 'underline'
                      : 'none',
                  }"
                >
                  {{ item.text && item.text.trim() ? item.text : item.url }}
                </a>
                </div>
              </div>
            </div>
            <!-- 保存/加载控制 -->
            <div v-if="editMode" class="save-load-controls">
              <button @click="saveContent">保存本地</button>
              <button @click="loadContent">加载本地</button>
              <button @click="resetContent">重置内容</button>
              <button @click="goList" class="back-list-btn">返回列表</button>
            </div>
          </div>
          <div v-if="!editMode " class="preview-controls">
            <div v-if="!publishedUrl">
              <button @click="toggleEditMode">返回编辑</button>
              <button @click="publishContent" class="publish-button">提交发布</button>
              <button @click="goList" class="back-list-btn">返回列表</button>
            </div>

            <!-- Add this new section to show published URL -->
            <div v-if="publishedUrl" class="published-url-section">
               <!-- <input type="text" :value="publishedUrl" readonly class="url-input" ref="urlInput"> -->
               <div class="url-display-box" ref="urlDisplay">
                {{ publishedUrl }}
              </div>
              <div class="url-display">
                <button @click="copyUrl" class="copy-button">复制链接</button>
                <!-- <button @click="toggleNewEditMode" class="copy-button">继续编辑</button> -->
                <button @click="goList" class="copy-button">返回列表</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, nextTick } from "vue";
import { ElMessage } from "element-plus";
import clipboard3 from "vue-clipboard3";
import { debounce } from 'lodash-es';
import { get,postData } from "@/utils/request";
interface ContentItemStyle {
  fontSize?: string;
  fontWeight?: string;
  fontStyle?: string;
  textDecoration?: string;
  color?: string;
  textAlign?: string;
  lineHeight?: number;
  background?: string;
  border?: string;
  [key: string]: any;
}

interface ContentItem {
  type: string;
  content?: string;
  text?: string;
  src?: string;
  alt?: string;
  link?: string;
  url?: string;
  style: ContentItemStyle;
  uid?: string;
}
type ContentItemPayload = Omit<ContentItem, 'uid'>;
interface EditableRefs {
  [key: number]: HTMLElement;
}
interface UploadStatus {
  type: 'loading' | 'success' | 'error';
  message: string;
}

export default defineComponent({
  name: "DynamicContentEditor",
  data() {
    return {
      pageTitle: '',
      id: undefined as number | undefined, // 新增id字段
      editMode: true,
      activeTextIndex: -1,
      contentItems: [] as ContentItem[],
      lastSelection: null as Range | null,
      isComposing: false, // 用于处理中文输入法
      editableRefs: {} as EditableRefs,
      predefinedColors: [
        "#000000", // 黑色
        "#FFFFFF", // 白色
        "#FF0000", // 红色
        "#00FF00", // 绿色
        "#0000FF", // 蓝色
        "#FFFF00", // 黄色
        "#FF00FF", // 紫色
        "#00FFFF", // 青色
        "#FFA500", // 橙色
        "#808080", // 灰色
        "#A52A2A", // 棕色
        "#008000", // 深绿色,
      ],
      activeColorPicker: -1, // 当前打开的颜色选择器索引
      publishedUrl: "", // 存储发布后的URL
      fileInputRefs: {} as { [key: string]: HTMLInputElement },
      uploadStatus: {} as Record<number, UploadStatus>, // 存储上传状态
      copiedTextBlocks: {} as Record<number, boolean>, // 记录每个文字块的复制状态
      visualViewportOffsetTop: 0,
      viewportCleanup: null as null | (() => void),
    };
  },
  created() {
  // 从路由参数获取id
  const routeId = this.$route.query.id;
    if (routeId) {
      this.id = Number(routeId);
      this.getDetail();
    } else {
      this.loadContent(); // 没有id则加载本地存储的内容
    }
  },
  mounted() {
    this.setupViewportListener();
    // 初始化后同步内容到可编辑div
    nextTick(() => {
      this.syncContentToEditableDivs();
    });
  },
  beforeUnmount() {
    if (this.viewportCleanup) {
      this.viewportCleanup();
      this.viewportCleanup = null;
    }
    if (typeof document !== 'undefined') {
      document.documentElement?.style.removeProperty('--viewport-offset-top');
    }
  },
  methods: { 
    generateItemId(): string {
      return `item-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
    },
    ensureItemIds(items: ContentItem[]): ContentItem[] {
      return items.map((item) => ({
        ...item,
        uid: item.uid || this.generateItemId(),
      }));
    },
    prepareItemsForPublish(items: ContentItem[]): ContentItemPayload[] {
      return items.map(({ uid, ...rest }) => ({ ...rest }));
    },
    goList() {
     this.$router.push({ path: '/pages' });
    },
    // 触发图片上传
    setFileInputRef(el: HTMLInputElement | null, index: number): void {
    if (el) {
      this.fileInputRefs[`fileInput-${index}`] = el;
    }
  },

  // 修改 triggerImageUpload 方法
  triggerImageUpload(index: number): void {
    const fileInput = this.fileInputRefs[`fileInput-${index}`];
    if (fileInput) {
      fileInput.click();
    } else {
      console.error('未找到文件输入元素');
    }
  },
    // 处理图片上传
    // 修改 handleImageUpload 方法
    async handleImageUpload(event: Event, index: number): Promise<void> {
      const input = event.target as HTMLInputElement;
      if (!input.files || input.files.length === 0) return;

      const file = input.files[0];
      
      // 验证文件类型
      if (!file.type.startsWith('image/')) {
        ElMessage.error('请选择图片文件');
        return;
      }

      // 设置上传状态
      this.uploadStatus[index] = {
        type: 'loading',
        message: '上传中...'
      };

      try {
         // 创建FormData
        const formData = new FormData();
        formData.append('file', file);
        // 调用上传接口
        const response = await fetch('/kafuFour/api/image/upload', {
          method: 'POST',
          body: formData
        });
        const result = await response.json();
        this.contentItems[index].src = result.url;
        // 更新上传状态
        this.uploadStatus[index] = {
          type: 'success',
          message: '上传成功'
        };
        
        ElMessage.success('图片上传成功');
      } catch (error) {
        console.error('图片上传失败:', error);
        
        // 更新上传状态
        this.uploadStatus[index] = {
          type: 'error',
          message: `上传失败: ${(error as Error).message || '未知错误'}`
        };
        
        ElMessage.error('图片上传失败');
      } finally {
        // 清空文件输入框，允许重复选择同一文件
        input.value = '';
        
        // 5秒后清除状态提示
        setTimeout(() => {
          delete this.uploadStatus[index];
        }, 5000);
      }
    },
    // 获取详情数据
    async getDetail() {
      try {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const res = await get<{title: string; content: {items: any[]}}>(
          `/kafuFour/jdUrl/lu1dou/detail/${this.id}`
        );
        console.log(res)
          // 更新内容
          this.pageTitle = res.title || '';
          this.contentItems = this.ensureItemIds(res.content.items || []);
          ElMessage.success("内容已从服务端存储加载");
          // 确保加载后同步内容到可编辑div
          this.$nextTick(() => {
            this.syncContentToEditableDivs();
          });
      } catch (error) {
        console.error("获取详情失败:", error);
        ElMessage.error("获取详情失败");
      }
    },
     async publishContent() {
      // 校验：标题不能为空
      if (!this.pageTitle || this.pageTitle.trim() === "") {
        ElMessage.error("请填写标题");
        return;
      }
      // 校验：至少有一个内容模块
      if (!this.contentItems || this.contentItems.length === 0) {
        ElMessage.error("请至少新增一个内容模块");
        return;
      }
      try {
        const payloadItems = this.prepareItemsForPublish(this.contentItems);
        const paylod = {
          id: this.id,
          title: this.pageTitle,
          content: { items: payloadItems }
        };
        await postData(`kafuFour/jdUrl/lu1dou/add`, paylod)
          .then((res) => {
            console.log("res", res);
            const currentRootUrl = window.location.origin;
            this.publishedUrl = `${currentRootUrl}/view?key=` + res || "";
          })
          .catch((error) => {
            console.error("Error:", error);
          });
        console.log("发布内容", this.publishedUrl);
        // Copy URL to clipboard
        const { toClipboard } = clipboard3();
        await toClipboard(this.publishedUrl);

        ElMessage.success({
          message: `发布成功！URL已复制到剪贴板: ${this.publishedUrl}`,
          duration: 5000,
          showClose: true
        });
      } catch (error) {
        console.error("发布失败:", error);
        ElMessage.error("发布失败，请重试");
      }
    },
    async copyUrl() {
      try {
        const { toClipboard } = clipboard3();
        await toClipboard(this.publishedUrl);
        ElMessage.success('链接已复制到剪贴板');
      } catch (error) {
        console.error('复制失败:', error);
        ElMessage.error('复制链接失败');
      }
    },
    toggleColorPicker(index: number): void {
      if (this.activeColorPicker === index) {
        this.activeColorPicker = -1; // 关闭颜色选择器
      } else {
        // 保存当前选区（在打开颜色选择器时）
        console.log("开始保存选中");
        this.saveSelection();
        this.activeColorPicker = index;
      }

      // 确保编辑器保持焦点
      const editableDiv = this.editableRefs[index];
      if (editableDiv) editableDiv.focus();
    },
    applyTextColor(index: number, color: string): void {
      const editableDiv = this.editableRefs[index];
      if (!editableDiv) return;
      console.log("开始恢复选中");
      // 恢复选区（确保颜色作用于选中文字）
      this.restoreSelection();

      // 确保编辑器获得焦点
      editableDiv.focus();

      // 3. 恢复选区（防止点击颜色按钮时丢失焦点）
      this.restoreSelection();

      // 使用execCommand应用颜色
      document.execCommand("styleWithCSS", false, undefined);
      document.execCommand("foreColor", false, color);

      // 更新内容
      this.contentItems[index].content = editableDiv.innerHTML;

      // 更新颜色按钮的显示颜色
      this.contentItems[index].style.color = color;

      // 关闭颜色选择器
      this.activeColorPicker = -1;

      // 恢复选区
      nextTick(() => {
        this.restoreSelection();
      });
    },
    async handleButtonClick(item: ContentItem): Promise<void> {
      if (item.type === "button" && item.link) {
        try {
          const { toClipboard } = clipboard3();
          const textToCopy = item.text
            ? `${item.text}\n${item.link}`
            : item.link;
          await toClipboard(textToCopy);

          let alertMessage = "一键复制 打开京東app查看";
          const urls = item.link.match(/http.+?\s/);

          if (urls && urls.length >= 0 && urls[0].includes("tb.cn")) {
            alertMessage = "一键复制 打开淘宝app查看";
          }

          ElMessage({
            message: `<span style="--el-message-text-color: #f5f5f5; color:#f5f5f5;">${alertMessage}<span>`,
            type: "success",
            customClass: "msgInfo",
            dangerouslyUseHTMLString: true,
          });

          if (
            this.isMobile() &&
            urls &&
            urls.length >= 0 &&
            urls[0].includes("m.tb.cn")
          ) {
            location.href = urls[0]
              .replace("m.tb.cn", "s.tb.cn")
              .replace(/\s/g, "");
          } else if (this.isMobile()) {
            // 如果是移动端但不是淘宝链接，直接打开链接
            window.open(item.link, "_blank");
          }
        } catch (error) {
          console.error("复制失败:", error);
          // 复制失败时直接打开链接
          window.open(item.link, "_blank");
        }
      }
    },
    // 新增：设置可编辑div的引用
    setEditableRef(el: HTMLElement | null, index: number): void {
      if (el) {
        this.editableRefs[index] = el;
      }
    },
    setupViewportListener(): void {
      if (typeof window === 'undefined' || !window.visualViewport) {
        return;
      }
      const viewport = window.visualViewport;
      const updateOffset = () => {
        const offsetTop = Math.max(viewport.offsetTop || 0, 0);
        this.visualViewportOffsetTop = offsetTop;
        if (typeof document !== 'undefined') {
          document.documentElement?.style.setProperty('--viewport-offset-top', `${offsetTop}px`);
        }
      };
      updateOffset();
      viewport.addEventListener('resize', updateOffset);
      viewport.addEventListener('scroll', updateOffset);
      this.viewportCleanup = () => {
        viewport.removeEventListener('resize', updateOffset);
        viewport.removeEventListener('scroll', updateOffset);
      };
    },
    // 修改getTextStyle方法，移除color属性
    // 修改getTextStyle方法，保留默认颜色
    // 修改getTextStyle方法
    getTextStyle(style: ContentItemStyle): Record<string, string> {
      const baseStyle = {
        fontSize: "12px",
        padding: "15px",
        border: "1px dashed #ddd",
        outline: "none",
        textAlign: style.textAlign || "left",
        lineHeight: style.lineHeight ? String(style.lineHeight) : "1.5",
      };

      // 仅添加不冲突的样式
      if (style.fontSize) {
        baseStyle.fontSize = style.fontSize;
      }

      return baseStyle;
    },
    // 修改syncContentToEditableDivs方法
     // 改进syncContentToEditableDivs方法
    syncContentToEditableDivs(): void {
      this.contentItems.forEach((item, index) => {
        if (item.type === 'text') {
          const editableDiv = this.editableRefs[index];
          if (editableDiv) {
            // 保存当前选区
            const selection = window.getSelection();
            const range = selection && selection.rangeCount > 0 ? selection.getRangeAt(0) : null;
            const hadFocus = document.activeElement === editableDiv;

            // 同步内容
            const content = item.content || "";
            if (editableDiv.innerHTML !== content) {
              editableDiv.innerHTML = content;
            }

            // 恢复焦点和选区
            if (hadFocus) {
              editableDiv.focus();
              if (range && editableDiv.contains(range.commonAncestorContainer)) {
                selection?.removeAllRanges();
                selection?.addRange(range);
              }
            }
          }
        }
      });
    },

    setActiveTextIndex(index: number): void {
      this.activeTextIndex = index;
      this.saveSelection();
    },

    // 修改saveSelection方法
    saveSelection(): void {
      const selection = window.getSelection();
      if (selection && selection.rangeCount > 0) {
        const range = selection.getRangeAt(0);
        const editableDiv = this.editableRefs[this.activeTextIndex];
        // 检查editableDiv是否存在且包含选区
        if (
          editableDiv &&
          range.commonAncestorContainer &&
          editableDiv.contains(range.commonAncestorContainer)
        ) {
          // 打印选中的文字
          const selectedText = range.toString();
          console.log("当前选中的文字:", selectedText);

          // 打印选区所在的 DOM 节点（调试用）
          console.log("选区所在的节点:", range.commonAncestorContainer);
          this.lastSelection = range;
        }
      }
    },
    toggleEditMode(): void {
      this.editMode = !this.editMode;
      this.publishedUrl = "";
    },
    toggleNewEditMode(): void {
      this.editMode = !this.editMode;
      this.publishedUrl = "";
      this.contentItems = [];
    },
    addTextBlock(): void {
      this.contentItems.push({
        uid: this.generateItemId(),
        type: "text",
        content: "", // 改为空内容，而不是默认文本
        style: {
          fontSize: "16px",
          fontWeight: "normal",
          fontStyle: "normal",
          textDecoration: "none",
          color: "#000000",
          textAlign: "left",
          lineHeight: 1.5,
          margin: "15px 0",
        },
      });

      // 确保新添加的文本块可以立即编辑
      this.$nextTick(() => {
        const newIndex = this.contentItems.length - 1;
        const editableDiv = this.editableRefs[newIndex];
        if (editableDiv) {
          editableDiv.focus();
        }
      });
    },
    addImageBlock(): void {
      this.contentItems.push({
        uid: this.generateItemId(),
        type: "image",
        src: "https://img-haodanku-com.cdn.fudaiapp.com/FjZCNgjJWUvyR8rFPRst1skQPRSM_600",
        alt: "图片",
        style: {
          border: "",
          width: "100%",
        },
      });
    },
    addButtonBlock(): void {
      this.contentItems.push({
        uid: this.generateItemId(),
        type: "button",
        text: "点击按钮",
        link: "https://example.com",
        style: {
          background:
            "linear-gradient(90deg, rgb(251, 136, 77) 0%, rgb(247, 62, 40) 100%)",
          color: "#ffffff",
          width: "100%",
          height: "50px",
          borderRadius: "3px",
          border: "none",
          fontSize: "16px",
          fontWeight: "bold",
          marginTop: "0px",
          cursor: "pointer",
        },
      });
    },
    addLinkBlock(): void {
      this.contentItems.push({
        uid: this.generateItemId(),
        type: "link",
        text: "点击链接",
        url: "https://example.com",
        style: {
          color: "#0066cc",
          textDecoration: "underline",
        },
      });
    },
    removeItem(uid?: string, fallbackIndex?: number): void {
      let targetIndex = -1;
      if (uid) {
        targetIndex = this.contentItems.findIndex((item) => item.uid === uid);
      }
      if (targetIndex === -1 && typeof fallbackIndex === 'number') {
        targetIndex = fallbackIndex;
      }
      if (targetIndex === -1) return;
      this.contentItems.splice(targetIndex, 1);
      delete this.editableRefs[targetIndex];
      const reorderedRefs: EditableRefs = {};
      Object.keys(this.editableRefs).forEach((key) => {
        const numericKey = Number(key);
        if (!Number.isNaN(numericKey)) {
          const item = this.editableRefs[numericKey];
          if (item) {
            reorderedRefs[numericKey > targetIndex ? numericKey - 1 : numericKey] = item;
          }
        }
      });
      this.editableRefs = reorderedRefs;
    },
    moveUp(index: number): void {
        if (index > 0) {
          const item = this.contentItems.splice(index, 1)[0];
          this.contentItems.splice(index - 1, 0, item);

          // 确保内容同步
          this.$nextTick(() => {
            this.syncContentToEditableDivs();
          });
        }
      },

      moveDown(index: number): void {
        if (index < this.contentItems.length - 1) {
          const item = this.contentItems.splice(index, 1)[0];
          this.contentItems.splice(index + 1, 0, item);

          // 确保内容同步
          this.$nextTick(() => {
            this.syncContentToEditableDivs();
          });
        }
      },


    saveContent(): void {
      localStorage.setItem(
        "dynamicContent",
        JSON.stringify({
          items: this.contentItems,
        })
      );
      console.log(
        JSON.stringify({
          items: this.contentItems,
        })
      );
      ElMessage.success("内容已保存到本地存储");
    },
    // 修改loadContent方法
    loadContent(): void {
      let savedContent = localStorage.getItem("dynamicContent");
      let content = null;
      if (savedContent) {
          content = JSON.parse(savedContent);
      } else {
        content = {"items":[]}
      }
       try {
          this.contentItems = this.ensureItemIds(content.items || []);
          // 确保所有文本内容都有content属性
          this.contentItems.forEach(item => {
            if (item.type === 'text' && !item.content) {
              item.content = "";
            }
          });

          ElMessage.success("内容已从本地存储加载");

          // 确保加载后同步内容到可编辑div
          this.$nextTick(() => {
            this.syncContentToEditableDivs();
          });
        } catch (error) {
          console.error("加载内容失败:", error);
          ElMessage.error("加载内容失败");
        }
    },
    resetContent(): void {
      this.contentItems = [];
      ElMessage.success("内容已重置");
    },
    isMobile(): boolean {
      const userAgent = navigator.userAgent;
      const mobileKeywords = [
        "Mobile",
        "Android",
        "iPhone",
        "iPad",
        "Windows Phone",
      ];
      return mobileKeywords.some((keyword) => userAgent.includes(keyword));
    },
    // 在方法中使用
    updateTextContent: debounce(function(this: any, index: number, event: Event) {
      if (this.isComposing) return;
      const target = event.target as HTMLElement;
      this.contentItems[index].content = target.innerHTML;
      this.saveSelection();
    }, 300),
    // 修改restoreSelection方法
    restoreSelection(): void {
      if (!this.lastSelection) return;

      const selection = window.getSelection();
      if (selection) {
        try {
          selection.removeAllRanges();
          selection.addRange(this.lastSelection.cloneRange());
        } catch (e) {
          console.warn("恢复选区失败:", e);
          // 如果恢复失败，将光标放在末尾
          const editableDiv = this.editableRefs[this.activeTextIndex];
          if (editableDiv) {
            const range = document.createRange();
            range.selectNodeContents(editableDiv);
            range.collapse(false);
            selection.removeAllRanges();
            selection.addRange(range);
          }
        }
      }
    },
    // 添加中文输入法事件处理
    handleCompositionStart() {
      this.isComposing = true;
    },
    handleCompositionEnd(event: CompositionEvent, index: number) {
      this.isComposing = false;
      const target = event.target as HTMLElement;
      this.contentItems[index].content = target.innerHTML;
      this.saveSelection();
    },
    // 修改toggleTextStyle和applyTextStyle方法
    // 修改toggleTextStyle方法，统一样式应用方式
    toggleTextStyle(index: number, styleType: string): void {
      const editableDiv = this.editableRefs[index];
      if (!editableDiv) return;

      // 聚焦并保存选区
      editableDiv.focus();
      this.saveSelection();

      // 执行命令
      let command = "";
      let value = null;

      switch (styleType) {
        case "bold":
          command = "bold";
          break;
        case "italic":
          command = "italic";
          break;
        case "underline":
          command = "underline";
          break;
      }

      if (command) {
        document.execCommand("styleWithCSS", false, undefined);
        document.execCommand(command, false, undefined);
      }

      // 更新样式状态
      const computedStyle = window.getComputedStyle(editableDiv);
      this.contentItems[index].style.fontWeight = computedStyle.fontWeight;
      this.contentItems[index].style.fontStyle = computedStyle.fontStyle;
      this.contentItems[index].style.textDecoration =
        computedStyle.textDecoration;

      // 恢复选区
      nextTick(() => {
        this.restoreSelection();
      });
    },

    // 修改applyTextStyle方法，移除color相关的execCommand
    applyTextStyle(index: number, styleProp: string, value: any): void {
      const editableDiv = this.editableRefs[index];
      if (!editableDiv) return;

      editableDiv.focus();
      this.saveSelection();

      // 更新样式
      this.contentItems[index].style[styleProp] = value;

      // 执行命令（不再处理color）
      let command = "";
      let commandValue = value;

      switch (styleProp) {
        case "fontSize":
          command = "fontSize";
          // commandValue = value.replace('px', '');
          break;
        case "textAlign":
          command = "justify" + value.charAt(0).toUpperCase() + value.slice(1);
          break;
      }

      if (command) {
        console.log(command, commandValue);
        document.execCommand(command, false, commandValue);
      }

      // 对于颜色，直接设置样式
      if (styleProp === "color") {
        document.execCommand("styleWithCSS", false, "true");
        document.execCommand("foreColor", false, value);
      }

      // 恢复选区
      nextTick(() => {
        this.restoreSelection();
      });
    },
    // 复制文字块内容
    async copyTextContent(index: number, item: ContentItem): Promise<void> {
      try {
        const { toClipboard } = clipboard3();
        // 创建临时div来提取纯文本
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = item.content || '';
        const textContent = tempDiv.textContent || tempDiv.innerText || '';
        
        await toClipboard(textContent);
        
        // 标记为已复制
        this.copiedTextBlocks[index] = true;
        
        ElMessage.success('文字内容已复制');
      } catch (error) {
        console.error("复制失败:", error);
        ElMessage.error('复制失败，请重试');
      }
    }
  },
});
</script>

<style scoped>
.config-title-bar {
  display: flex;
  align-items: center;
  padding: 18px 0 8px 0;
  gap: 8px;
}
.config-title-label {
  font-size: 15px;
  color: #333;
  font-weight: bold;
}
.config-title-input {
  flex: 1;
  min-width: 200px;
  max-width: 400px;
  padding: 7px 12px;
  font-size: 15px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  outline: none;
  background: #fff;
  transition: border-color 0.2s;
}
.config-title-input:focus {
  border-color: #409eff;
}
.back-list-btn {
  background: #909399 !important;
  color: #fff;
  margin-left: 10px;
  padding: 8px 16px;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  font-size: 14px;
  transition: background 0.2s;
}
.back-list-btn:hover {
  background: #606266 !important;
}
.powerful_code-main {
  max-width: 750px;
  margin: auto;
  box-shadow: 0 0 10px 10px #f5f5f5;
  min-height: 100vh;
}

html,
body {
  font-size: 14px;
  line-height: 1.15;
}

* {
  margin: 0;
  padding: 0;
  -webkit-tap-highlight-color: transparent;
  box-sizing: border-box;
}

.editor-tools {
  padding: 10px;
  background: #f0f0f0;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  position: -webkit-sticky;
  position: sticky;
  top: calc(env(safe-area-inset-top, 0px) + var(--viewport-offset-top, 0px));
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

@media (max-width: 768px) {
  .powerful_code-main {
    padding-top: 95px;
  }

  .editor-tools {
    position: fixed;
    top: calc(env(safe-area-inset-top, 0px) + var(--viewport-offset-top, 0px));
    left: 50%;
    transform: translateX(-50%);
    width: min(100vw, 750px);
    border-radius: 0 0 12px 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
    z-index: 2000;
  }
}

.tool-section button,
.preview-toggle button,
.save-load-controls button {
  margin: 5px;
  padding: 8px 12px;
  background: #409eff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.tool-section button:hover,
.preview-toggle button:hover,
.save-load-controls button:hover {
  background: #66b1ff;
}

.rich-text-toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-bottom: 10px;
  padding: 5px;
  background: #f5f5f5;
  border-radius: 4px;
  align-items: center;
}

.rich-text-toolbar select,
.rich-text-toolbar input[type="color"],
.rich-text-toolbar input[type="number"],
.rich-text-toolbar input[type="text"] {
  padding: 5px;
  border: 1px solid #ddd;
  border-radius: 4px;
  height: 30px;
}

.rich-text-toolbar button {
  padding: 5px 10px;
  border: 1px solid #ddd;
  background: white;
  border-radius: 4px;
  cursor: pointer;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.rich-text-toolbar button.active {
  background: #e0e0e0;
}

.banner-img {
  margin: 0 0;
}

.banner-img img {
  width: 100%;
  display: block;
}


.content-item {
  position: relative;
  margin: 0 0 15px 0;
  border: 1px solid #eee;
  /* padding: 10px; */
}

.item-controls {
  position: absolute;
  top: -15px;
  right: 10px;
  background: white;
  padding: 2px 5px;
  border: 1px solid #ddd;
  border-radius: 4px;
  z-index: 10;
}

.item-controls button {
  margin: 0 2px;
  padding: 2px 5px;
  font-size: 12px;
  background: #f0f0f0;
  border: 1px solid #ccc;
}

.save-load-controls {
  margin: 20px 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.save-load-controls button {
  background: #67c23a;
}

.save-load-controls button:hover {
  background: #85ce61;
}

.page-app {
  display: block;
  border: none;
  outline: 1px solid #e8e8e8;
  box-sizing: border-box;
  background: white;
}

.page-app.active {
  /* height: 100vh; */
  display: flex;
  flex-direction: column;
}

.page-render {
  box-sizing: border-box;
  padding:10px;
  height: 100%;
  display: block;
}

.page-phone {
  background: rgb(255, 255, 255);
}

.editor-content-view {
  border: 1px solid #ddd;
  outline: none;
}

.editor-content-view:focus {
  border-color: #409eff;
}

/* 颜色选择器样式优化 */
.color-picker-wrapper {
  position: relative;
  display: inline-block;
  margin-right: 5px;
}

.color-picker-button {
  width: 24px;
  height: 24px;
  border: 1px solid #ddd;
  border-radius: 3px;
  cursor: pointer;
  padding: 0;
  vertical-align: middle;
  transition: all 0.2s;
}

.color-picker-button:hover {
  border-color: #409eff;
}

.color-picker-popup {
  position: absolute;
  top: 30px;
  left: 0;
  background: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 8px;
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 6px;
  z-index: 100;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.color-option {
  width: 20px;
  height: 20px;
  border-radius: 3px;
  cursor: pointer;
  border: 1px solid #f0f0f0;
  transition: all 0.2s;
}

.color-option:hover {
  transform: scale(1.2);
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
}

/* 新增样式用于统一控制栏 */
.rich-text-toolbar label {
  margin-right: 5px;
  white-space: nowrap;
}

.rich-text-toolbar input[type="checkbox"] {
  width: auto;
  height: auto;
}

/* 添加消息提示样式 */
::v-deep .el-message .el-message__content {
  background-color: black !important;
  color: white !important;
}

.custom_class {
  --el-message-text-color: #f5f5f5;
}

/* 按钮样式保持不变 */
.coppy_button {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 50px;
  border-radius: 3px;
  font-size: 16px;
  font-weight: bold;
  border: none;
  cursor: pointer;
  background: linear-gradient(
    90deg,
    rgb(251, 136, 77) 0%,
    rgb(247, 62, 40) 100%
  );
  color: white;
}
/* 按钮工具栏样式 */
.button-toolbar {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px;
}

.button-input-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.button-input-group label {
  min-width: 70px;
  font-size: 14px;
  color: #333;
}

.button-input {
  flex: 1;
  padding: 8px 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 14px;
  transition: border-color 0.2s;
}

.button-input:focus {
  border-color: #409eff;
  outline: none;
}

.button-style-group {
  display: flex;
  gap: 15px;
  margin-top: 5px;
}

.style-control {
  display: flex;
  align-items: center;
  gap: 8px;
}

.style-control label {
  font-size: 14px;
  color: #333;
}

.style-control input[type="color"] {
  width: 30px;
  height: 30px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  cursor: pointer;
}

/* 编辑模式下内容项的样式 */
.editing-item {
  position: relative;
  margin: 15px 0;
  padding: 15px;
  border: 2px dashed #409eff;
  border-radius: 8px;
  background-color: rgba(64, 158, 255, 0.05);
  transition: all 0.3s ease;
}

.editing-item:hover {
  background-color: rgba(64, 158, 255, 0.1);
  box-shadow: 0 0 10px rgba(64, 158, 255, 0.2);
}

.preview-controls {
  display: flex;
  justify-content: center;
  padding: 10px;
  background: #f0f0f0;
}

.preview-controls button {
  margin:5px;
  padding: 8px 16px;
  background-color: #409eff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.preview-controls button:hover {
  background-color: #66b1ff;
}

.preview-controls .publish-button {
  background-color: #67c23a;
}

.preview-controls .publish-button:hover {
  background-color: #85ce61;
}

.link_box{
  margin-bottom: 10px;
}

.published-url-section {
  margin-top: 15px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.url-display {
  display: flex;
  width: 100%;
  max-width: 500px;
  margin: 10px 0;
}

.url-input {
  flex: 1;
  padding: 8px 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px 0 0 4px;
  font-size: 14px;
  background: #f5f5f5;
  overflow: hidden;
  text-overflow: ellipsis;
}

.copy-button {
  padding: 8px 15px;
  background-color: #409eff;
  color: white;
  border: none;
  border-radius: 0 4px 4px 0;
  cursor: pointer;
  font-size: 14px;
  white-space: nowrap;
}

.copy-button:hover {
  background-color: #66b1ff;
}

/* Adjust preview controls layout */
.preview-controls {
  display: block;
  flex-direction: column;
  align-items: center;
  padding: 15px;
  background: #f0f0f0;
  gap: 10px;
}

.preview-controls button {
  width: 100%;
  max-width: 200px;
}

/* 新增样式 - 大输入框和清空按钮 */
.large-input {
  flex: 1;
  padding: 10px 15px;
  font-size: 16px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  transition: border-color 0.2s;
}

.large-input:focus {
  border-color: #409eff;
  outline: none;
}

.url-input-group {
  display: flex;
  align-items: center;
  gap: 5px;
  width: 100%;
}

.clear-button {
  padding: 0 8px;
  height: 38px;
  background: #f56c6c !important;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.clear-button:hover {
  background: #f78989;
}

.style-control-group {
  display: flex;
  gap: 15px;
  margin-top: 10px;
}

.image-upload-group {
  display: flex;
  align-items: center;
  gap: 10px;
}

.upload-btn {
  padding: 8px 15px;
  background-color: #67c23a;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.2s;
}

.upload-btn:hover {
  background-color: #85ce61;
}
/* 确保图片工具栏样式合理 */
.banner-img .rich-text-toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 10px;
  align-items: center;
}

/* 文字块复制按钮样式 */
.rich-text-box-wrapper {
  position: relative;
}

.copy-text-btn {
  position: absolute;
  top: 5px;
  right: 5px;
  padding: 0;
  background: none;
  color: #1E90FF;
  border: none;
  cursor: pointer;
  font-size: 14px;
  z-index: 10;
  transition: color 0.3s ease;
  font-weight: normal;
}

.copy-text-btn:hover {
  color: #0066CC !important;
}

.copy-text-btn.copied {
  color: #666666 !important;
}

.copy-text-btn.copied:hover {
  color: #999999 !important;
}
</style>
